// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';
import { default as utils } from '../utils.js';

class MeetingServiceInterface {
  constructor() {
    this.service_id = 'meetingservice-1_0';
    this.predefined_labels = ["favourite"];
  }

  getPredefinedLabels(success_callback) {
    return new Promise((resolve, reject) => {
      if (success_callback) {
        success_callback(this.predefined_labels);
      }
      resolve(this.predefined_labels);
    });
  }

  // AuthorizeSession, Response: AuthorizationResponse
  // projectId: int
  // sessionId: int
  authorizeSession(projectId, sessionId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AuthorizeSession', { projectId: projectId, sessionId: sessionId }, success_callback);
  }

  // AuthorizeSessionSurvey, Response: AuthorizationResponse
  // projectId: int
  // sessionId: int
  // surveyId: String
  authorizeSessionSurvey(projectId, sessionId, surveyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'AuthorizeSessionSurvey', { projectId: projectId, sessionId: sessionId, surveyId: surveyId }, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // project_id: int
  subscribeToProject(project_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/meetingshard/dashboard/project/' + project_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/meetingshard/dashboard/project/' + project_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // session_id: int
  // project_id: int
  subscribeToDiscussionTopicList(session_id, project_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/meetingshard/project/' + project_id + '/topics/admin/' + session_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/meetingshard/project/' + project_id + '/topics/admin/' + session_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // project_id: int
  subscribeToProjectProfile(project_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/meetingshard/project/' + project_id + '/profile', filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/meetingshard/project/' + project_id + '/profile' } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // SubscribeToActionableMeetingRequest
  subscribeToActionableMeetingRequest(tenancyId, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'SubscribeToActionableMeetingRequest', data: { tenancyId: tenancyId } };
    var unsubscribe_msg = { service: this.service_id, message: 'UnsubscribeFromActionableMeetingRequest', data: { tenancyId: tenancyId } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
    //    ws.sendServiceRequest(this.service_id, 'SubscribeToActionableMeetingRequest', {}, success_callback)
  }

  // ProjectShareStatusSubscribeRequest
  subscribeToProjectShareStatus(project_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'ProjectShareStatusSubscribeRequest', data: { projectId: project_id } };
    var unsubscribe_msg = { service: this.service_id, message: 'ProjectShareStatusUnsubscribeRequest', data: { projectId: project_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // SessionUsageCountRequest, Response: SessionUsageCount
  // projectId: int
  // sessionId: int
  getSessionUsageCount(projectId, sessionId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SessionUsageCountRequest', { projectId: projectId, sessionId: sessionId }, success_callback);
  }

  // GetMeetingConnectionCountRequest, Response: MeetingConnectionCount
  // projectId: int
  getMeetingConnectionCount(projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetMeetingConnectionCountRequest', { projectId: projectId }, success_callback);
  }

  // ProjectLockStateChangeAction, Response: ProjectLockState
  // projectId: int
  // tenancyId: int
  // state: ProjectLockStateEnum
  // stateMessage: Optional<String>
  // userId: String
  // timeout: long
  updateProjectLockState(projectId, tenancyId, state, stateMessage, userId, timeout, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectLockStateChangeAction', { projectId: projectId, tenancyId: tenancyId, state: state, stateMessage: stateMessage, userId: userId, timeout: timeout }, success_callback);
  }

  // ProjectLockStateRequest, Response: ProjectLockStateResponse
  // projectId: int
  // timeout: long
  // includeHistory: Optional<Boolean>
  getProjectLockState(projectId, timeout, includeHistory, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectLockStateRequest', { projectId: projectId, timeout: timeout, includeHistory: includeHistory }, success_callback);
  }

  changeState(tenancyId, projectId, projectStateEnum, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectStateChangeAction', { tenancyId: tenancyId, projectId: projectId, projectState: projectStateEnum }, success_callback);
  }

  startProjectChecked(tenancyId, projectId, toHold, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectStartCheckedAction', { tenancyId: tenancyId, projectId: projectId, projectIdsToHold: toHold }, success_callback);
  }

  // VerifyMeetingInitializedRequest, Response: VerifyMeetingInitializedResponse
  // projectId: int
  verifyMeetingInitialized(projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'VerifyMeetingInitializedRequest', { projectId: projectId }, success_callback);
  }

  // GetSessionListRequest, Response: GetSessionListResponse
  // projectId: int
  getSessionList(projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetSessionListRequest', { projectId: projectId }, success_callback);
  }

  // MeetingListRequest, Response: MeetingListResponse
  // tenancyId: int
  getMeetingList(tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'MeetingListRequest', { tenancyId: tenancyId }, success_callback);
  }

  // FilteredMeetingListRequest, Response: FilteredMeetingListResponse
  // tenancyId: int
  getFilteredMeetingList(tenancyId, index, noOfMeetings, filter, sort, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'FilteredMeetingListRequest', { tenancyId: tenancyId, index: index, noOfMeetings: noOfMeetings, filter: filter, sort: sort }, success_callback);
  }

  // UserNamesRequest, Response: UserNamesResponse
  // tenancyId: int
  getUserNamesList(tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UserNamesRequest', { tenancyId: tenancyId }, success_callback);
  }

  // ProjectOwnersRequest, Response: ProjectOwnersResponse
  // tenancyId: int
  getProjectOwnersList(tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectOwnersRequest', { tenancyId: tenancyId }, success_callback);
  }

  // ProjectCreateAction, Response: Integer
  // tenancy_id: int
  // name: String
  // single_session: boolean
  // project_type: ProjectType
  // feature_set: Object
  // jstz: Object
  // moment: Object
  createProjectDefault(request, feature_set, jstz, moment, success_callback) {
    let single_session = request.singleSession;
    let project_type = request.projectType;

    var d1 = new Date(),
        d2 = new Date();
    if (single_session) {
      var m = Math.floor(d1.getMinutes() / 15) * 15 % 60;
      d1.setMinutes(m);
      d2.setHours(d1.getHours() + 1);
      d2.setMinutes(m);
    } else {
      d1.setHours(0);
      d1.setMinutes(0);
      d2.setDate(d1.getDate() + 1);
      d2.setHours(23);
      d2.setMinutes(59);
    }
    var time_zone = jstz.determine().name();
    var start_date = utils.serverDateToDateInTz(moment, jstz, d1).getTime();
    var end_date = utils.serverDateToDateInTz(moment, jstz, d2).getTime();
    var shared_user_ids = [];

    var project_state = single_session ? ProjectStateEnum.holding : ProjectStateEnum.started;
    project_state = project_type == ProjectType.agm ? ProjectStateEnum.informing : project_state;

    let create_request = {
      tenancyId: request.tenancyId,
      name: request.name,
      singleSession: request.singleSession,
      projectType: request.projectType,
      useDefaultProjectType: request.useDefaultProjectType,
      startDate: start_date,
      endDate: end_date,
      timeZone: time_zone,
      projectState: project_state,
      sharedUserIds: shared_user_ids
      //tenancyId: tenancyId, name: name, singleSession: singleSession, projectType: projectType, startDate: startDate, endDate: endDate, timeZone: timeZone, projectState: projectState, sharedUserIds: sharedUserIds }
    };return this.createProject(create_request, success_callback);
  }

  // ProjectCreateAction, Response: Integer
  // tenancyId: int
  // name: String
  // singleSession: boolean
  // projectType: ProjectType
  // startDate: DateTime
  // endDate: DateTime
  // timeZone: String
  // projectState: ProjectStateEnum
  // sharedUserIds: List<String>
  createProject(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectCreateAction', request, success_callback);
  }

  // ProjectEditAction, Response: Boolean
  // tenancyId: int
  // projectId: int
  // name: String
  // projectType: ProjectType
  // startDate: DateTime
  // endDate: DateTime
  // timeZone: String
  // shareWithUserIds: List<String>
  // unshareWithUserIds: List<String>
  editProject(tenancyId, projectId, name, projectType, startDate, endDate, timeZone, shareWithUserIds, unshareWithUserIds, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectEditAction', { tenancyId: tenancyId, projectId: projectId, name: name, projectType: projectType, startDate: startDate, endDate: endDate, timeZone: timeZone, shareWithUserIds: shareWithUserIds, unshareWithUserIds: unshareWithUserIds }, success_callback);
  }

  // ProjectDeleteAction, Response: Boolean
  // tenancyId: int
  // projectId: int
  // permanentDeletion: Optional<Boolean>
  deleteProject(tenancyId, projectId, permanentDeletion, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectDeleteAction', { tenancyId: tenancyId, projectId: projectId, permanentDeletion: permanentDeletion }, success_callback);
  }

  // ProjectCopyAction, Response: Boolean
  // tenancy_id: int
  // project_id: int
  // name: String
  // single_session: boolean
  copyProject(tenancy_id, project_id, name, single_session, jstz, moment, success_callback) {

    var d1 = new Date(),
        d2 = new Date();
    if (single_session) {
      var m = Math.floor(d1.getMinutes() / 15) * 15 % 60;
      d1.setMinutes(m);
      d2.setHours(d1.getHours() + 1);
      d2.setMinutes(m);
    } else {
      d1.setHours(0);
      d1.setMinutes(0);
      d2.setDate(d1.getDate() + 1);
      d2.setHours(23);
      d2.setMinutes(59);
    }
    var start_date = utils.serverDateToDateInTz(moment, jstz, d1).getTime();
    var end_date = utils.serverDateToDateInTz(moment, jstz, d2).getTime();

    return ws.sendServiceRequest(this.service_id, 'ProjectCopyAction', { tenancyId: tenancy_id, projectId: project_id, name: name, startDate: start_date, endDate: end_date }, success_callback);
  }

  // ChangeMeetingOwnerAction, Response: ChangeMeetingOwnerResponse
  // tenancyId: int
  // projectIds: [int]
  // newOwner: String
  changeMeetingOwner(tenancyId, projectIds, newOwner, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ChangeMeetingOwnerAction', { tenancyId: tenancyId, projectIds: projectIds, newOwner: newOwner }, success_callback);
  }

  // ProjectStateChangeAction, Response: Object
  // tenancyId: int
  // projectId: int
  // projectState: ProjectStateEnum
  changeProjectState(tenancyId, projectId, projectState, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectStateChangeAction', { tenancyId: tenancyId, projectId: projectId, projectState: projectState }, success_callback);
  }

  // ProjectStartCheckedAction, Response: Object
  // tenancyId: int
  // projectId: int
  // projectIdsToHold: Optional<List<Integer>>
  // forceStart: Optional<Boolean>
  startProjectChecked(tenancyId, projectId, projectIdsToHold, forceStart, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectStartCheckedAction', { tenancyId: tenancyId, projectId: projectId, projectIdsToHold: projectIdsToHold, forceStart: forceStart }, success_callback);
  }

  // CoHostUserRequest, Response: CoHostUserResponse
  // tenancyId: int
  // identity: Identity
  getCoHostUser(tenancyId, identity, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CoHostUserRequest', { tenancyId: tenancyId, identity: identity }, success_callback);
  }

  // ProjectUsersInfoRequest, Response: ProjectUsersInfoResponse
  // projectId: int
  // tenancyId: int
  getProjectUsersInfo(projectId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectUsersInfoRequest', { projectId: projectId, tenancyId: tenancyId }, success_callback);
  }

  // ProjectCustomizationPublishAction, Response: Boolean
  // projectId: int
  // tenancyId: int
  publishProjectCustomization(projectId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectCustomizationPublishAction', { projectId: projectId, tenancyId: tenancyId }, success_callback);
  }

  // ProjectCustomizationHomepageUpdateAction, Response: Boolean
  // projectId: int
  // tenancyId: int
  // projectTitle: String
  // projectSubtitle: String
  // projectText: String
  // projectImageRes: String
  // projectImageAlignment: String
  updateProjectCustomizationHomepage(projectId, tenancyId, projectTitle, projectSubtitle, projectText, projectImageRes, projectImageAlignment, projectImageAltText, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectCustomizationHomepageUpdateAction', { projectId: projectId, tenancyId: tenancyId, projectTitle: projectTitle, projectSubtitle: projectSubtitle, projectText: projectText, projectImageRes: projectImageRes, projectImageAlignment: projectImageAlignment, projectImageAltText: projectImageAltText }, success_callback);
  }

  // ProjectCustomizationThemeUpdateAction, Response: Boolean
  // projectId: int
  // tenancyId: int
  // projectThemeProperties: Map<String,String>
  // preserveActiveState: Boolean
  updateProjectCustomizationTheme(projectId, tenancyId, projectThemeProperties, preserveActiveState, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectCustomizationThemeUpdateAction', { projectId: projectId, tenancyId: tenancyId, projectThemeProperties: projectThemeProperties, preserveActiveState: preserveActiveState }, success_callback);
  }

  // CreateTenancyMeetingIdMappingsAction, Response: CreateTenancyMeetingIdMappingsResponse
  // projectId: int
  // externalMeetingIds: List<String>
  createTenancyMeetingIdMappings(projectId, externalMeetingIds, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateTenancyMeetingIdMappingsAction', { projectId: projectId, externalMeetingIds: externalMeetingIds }, success_callback);
  }

  // DeleteTenancyMeetingIdMappingsAction, Response: DeleteTenancyMeetingIdMappingsResponse
  // projectId: int
  clearTenancyMeetingIdMappings(projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteTenancyMeetingIdMappingsAction', { projectId: projectId }, success_callback);
  }

  // CreateProjectMeetingIdMappingsAction, Response: CreateProjectMeetingIdMappingsResponse
  // projectId: int
  // externalMeetingIds: List<ExternalMeetingId>
  createProjectMeetingIdMappings(projectId, externalMeetingIds, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateProjectMeetingIdMappingsAction', { projectId: projectId, externalMeetingIds: externalMeetingIds }, success_callback);
  }

  // DeleteProjectMeetingIdMappingsAction, Response: DeleteProjectMeetingIdMappingsResponse
  // projectId: int
  clearProjectMeetingIdMappings(projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteProjectMeetingIdMappingsAction', { projectId: projectId }, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // tenancy_id: int
  subscribeToProjectList(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/tenancyshard/tenancy/' + tenancy_id + '/projectlist', filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/tenancyshard/tenancy/' + tenancy_id + '/projectlist' } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // ChangeMeetingSettingsAction, Response: ChangeMeetingSettingsResponse
  // projectId: int
  // tenancyId: int
  // settings: List<MeetingSetting>
  // settingKeysToDelete: List<String>
  changeMeetingSettings(projectId, tenancyId, settings, settingKeysToDelete, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ChangeMeetingSettingsAction', { projectId: projectId, tenancyId: tenancyId, settings: settings, settingKeysToDelete: settingKeysToDelete }, success_callback);
  }

  subscribeToMeetingCUDRequestForTenancy(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "SubscribeToMeetingCUDRequest", data: { tenancyId: tenancy_id } };
    var unsubscribe_msg = { service: this.service_id, message: "UnsubscribeFromMeetingCUDRequest", data: { tenancyId: tenancy_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // CreatePublicMeetingAccessKeyRequest
  // {
  //   proejctId: int,
  //   keyType: String,
  //   reuseKeyIfExists: boolean,
  //   password: Optional<String>
  //   storeAsPlainText: Optional<Boolean>
  // }
  // CreatePublicMeetingAccessKeyResponse
  // {
  //   key: PublicMeetingAccessKey
  // }
  createPublicMeetingAccessKey(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreatePublicMeetingAccessKeyRequest', request, success_callback);
  }

  deletePublicMeetingAccessKey(project_id, key_type, key_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeletePublicMeetingAccessKeyRequest', { projectId: project_id, keyType: key_type, keyId: key_id }, success_callback);
  }

  // SetPublicMeetingAccessActiveStateAction
  // {
  //   proejctId: int,
  //   keyId: String,
  //   active: boolean
  // }
  // SetPublicMeetingAccessActiveStateResponse
  // {
  // }
  setPublicMeetingAccessActiveState(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetPublicMeetingAccessActiveStateAction', request, success_callback);
  }

  // SetPublicMeetingAccessPasswordAction
  // {
  //   proejctId: int,
  //   keyId: String,
  //   password: Optional<String>
  //   storeAsPlainText: Optional<Boolean>
  // }
  // SetPublicMeetingAccessPasswordResponse
  // {
  // }
  setPublicMeetingAccessPassword(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetPublicMeetingAccessPasswordAction', request, success_callback);
  }

  // ProjectInviteEmailRequest, Response: string
  // tenancyId: int
  // projectId: int
  getProjectInviteEmail(tenancyId, projectId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectInviteEmailRequest', { tenancyId: tenancyId, projectId: projectId }, success_callback);
  }

  /*
  MeetingBrandingRequest = {
    tenancyId: int,
  }
   Response type: MeetingBrandingResponse
  */
  getMeetingBranding(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'MeetingBrandingRequest', request, success_callback);
  }

  /*
    GettingStartedInfoRequest = {
      tenancyId: int,
    }
     Response type: GettingStartedInfoResponse {
      posterUrl: Optional<String>
      videoUrl: Optional<String>
    }
  */
  getGettingStartedInfo(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GettingStartedInfoRequest', request, success_callback);
  }

  /*ConvertSurveyToPollAction {
  public abstract int tenancyId();
  public abstract int projectId();
  public abstract int sessionId();
  public abstract String surveyId();
  public abstract Boolean asGroupPoll();
  }*/
  convertSurveyToPoll(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ConvertSurveyToPollAction', request, success_callback);
  }

  /*
  GetConnectedUsersRequest {
  public abstract int tenancyId();
  public abstract int projectId();
  }
  */
  getConnectedUsers(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetConnectedUsersRequest', request, success_callback);
  }

  /*
    UpdateClientAccessAction = {
      projectId: int,
      tenancyId: int,
      emailAddresses: List<String>,
      groupIds: List<String>,
      samlConfigId: Optional<String>
    }
     Response type: UpdateClientAccessResponse {
      projectId: int,
    }
  */
  updateClientAccess(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateClientAccessAction', request, success_callback);
  }

  /*
  ProjectInfoRequest {
  accessCode: String
  }
  */
  getProjectInfo(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ProjectInfoRequest', request, success_callback);
  }

  /*
  static abstract class AbstractInviteDashboardUsersWithMeetingAction {
  public abstract int tenancyId();
  public abstract List<String> emails();
  public abstract List<String> givenRoles();
  public abstract Optional<String> department();
  public abstract String invitationURL();
  public abstract Optional<String> invitationType();
  public abstract List<Integer> inviteToProjectIds();
  }
  */
  inviteDashboardUsersWithMeeting(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'InviteDashboardUsersWithMeetingAction', request, success_callback);
  }

  /*
  static abstract class AbstractMeetingDeviceAuthTypeRequest {
  public abstract int projectId();
  }
  */
  getMeetingDeviceAuthenticationType(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'MeetingDeviceAuthTypeRequest', request, success_callback);
  }

  // subscribeToProjectLabels
  // tenancy_id: int
  subscribeToProjectLabels(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "ProjectLabelListSubscribeRequest", data: { tenancyId: tenancy_id } };
    var unsubscribe_msg = { service: this.service_id, message: "ProjectLabelListUnsubscribeRequest", data: { tenancyId: tenancy_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

}

export const ProjectLockStateEnum = Object.freeze({
  normal: 'normal',
  logging: 'logging',
  locked: 'locked'
});

export const ProjectType = Object.freeze({
  anonymous: 0,
  lite: 1,
  authenticated: 2,
  thirdParty: 3,
  agm: 4,
  authenticated_anonymous: 5,
  authenticated_lite: 6
});

export const ProjectStateEnum = Object.freeze({
  holding: 0,
  started: 1,
  stopped: 2,
  informing: 3
});

export const meetingService = new MeetingServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/meetingservice.js
// module id = 7p0B
// module chunks = 1 2 3 4 5 6